import { Controller } from "@hotwired/stimulus";

// Live price recalculation for step3, mirroring step2_price_controller.js's
// approach: base order price (the form's order-sales-price attribute,
// matching the original's `$("#step_3_form").attr("order-sales-price")`)
// plus whichever addon/package/upgrade statement rows are currently
// selected. Rows carry data-row-key so this controller can independently
// figure out whether each one should be visible (rather than each
// addon/package/upgrade controller reaching into the price table itself).
export default class extends Controller {
  static targets = ["row", "total"];

  connect() {
    if (this.hasTotalTarget) {
      const match = this.totalTarget.textContent.trim().match(/[^\d\s.,]+$/);
      this.currencySuffix = match ? ` ${match[0]}` : "";
    }
    this.baseSalesPrice = Number(this.element.querySelector("#step_3_form")?.getAttribute("order-sales-price")) || 0;
    this.recalculate();
  }

  recalculate() {
    let total = this.baseSalesPrice;

    this.rowTargets.forEach((row) => {
      const show = this.shouldShow(row.dataset.rowKey);
      const wasShown = row.dataset.shown === "true";

      // Move a row to the end of the list the moment it becomes visible, so
      // the thing just chosen reads as the latest addition rather than
      // appearing wherever it happened to be rendered. Only on the
      // transition -- reordering on every recalculate would shuffle the
      // list on unrelated changes. These rows are rendered last in
      // step3/_products.html.erb for the same reason, which keeps the
      // initial order sensible before anything is picked.
      if (show && !wasShown && row.parentNode) row.parentNode.appendChild(row);

      row.classList.toggle("hidden", !show);
      row.dataset.shown = show ? "true" : "false";
      if (show) total += Number(row.dataset.salesPrice) || 0;
    });

    // totalTargets (plural), not the singular accessor -- the mobile sticky
    // price bar (see step_3.html.erb) is a second element carrying this
    // same target so both stay in sync.
    this.totalTargets.forEach((el) => {
      el.textContent = this.formatPrice(total);
    });
  }

  shouldShow(key) {
    if (key === "upgrade") {
      const upgrade = this.element.querySelector('input[name="upgrade"]');
      return upgrade && upgrade.value === "1";
    }
    if (key.startsWith("package_")) {
      const selected = this.element.querySelector('input[name="package"]:checked');
      return !!selected && selected.value === key.replace("package_", "");
    }
    if (key.startsWith("addon_")) {
      const id = key.replace("addon_", "");
      const yesRadio = this.element.querySelector(`#addon_${id}_true`);
      return !!yesRadio && yesRadio.checked;
    }
    return false;
  }

  formatPrice(amount) {
    return `${Math.round(amount).toLocaleString("sv-SE")}${this.currencySuffix || ""}`;
  }
}
